import { type ReactNode } from 'react';

import styles from './Installation.module.css';

export const GoInstallation = (): ReactNode => {
  return (
    <ul className={styles.installationInstructionsList}>
      <li>
        If you are using the standard <code>Go</code> modules system, import the SDK packages in your code and{' '}
        <code>go build</code> will automatically download them. The SDK and its dependencies are modules.
      </li>
      <li>Alternatively, you can run the following command:</li>
    </ul>
  );
};
